/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkCreateSystemUserItemRequest } from './BulkCreateSystemUserItemRequest';
import {
    BulkCreateSystemUserItemRequestFromJSON,
    BulkCreateSystemUserItemRequestFromJSONTyped,
    BulkCreateSystemUserItemRequestToJSON,
    BulkCreateSystemUserItemRequestToJSONTyped,
} from './BulkCreateSystemUserItemRequest';

/**
 * 
 * @export
 * @interface BulkCreateSystemUsersRequest
 */
export interface BulkCreateSystemUsersRequest {
    /**
     * 
     * @type {Array<BulkCreateSystemUserItemRequest>}
     * @memberof BulkCreateSystemUsersRequest
     */
    users: Array<BulkCreateSystemUserItemRequest>;
    /**
     * Target subscription plan assigned to all inserted users
     * @type {string}
     * @memberof BulkCreateSystemUsersRequest
     */
    subscriptionPlanId: string;
    /**
     * 
     * @type {string}
     * @memberof BulkCreateSystemUsersRequest
     */
    countryState: string;
}

/**
 * Check if a given object implements the BulkCreateSystemUsersRequest interface.
 */
export function instanceOfBulkCreateSystemUsersRequest(value: object): value is BulkCreateSystemUsersRequest {
    if (!('users' in value) || value['users'] === undefined) return false;
    if (!('subscriptionPlanId' in value) || value['subscriptionPlanId'] === undefined) return false;
    if (!('countryState' in value) || value['countryState'] === undefined) return false;
    return true;
}

export function BulkCreateSystemUsersRequestFromJSON(json: any): BulkCreateSystemUsersRequest {
    return BulkCreateSystemUsersRequestFromJSONTyped(json, false);
}

export function BulkCreateSystemUsersRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkCreateSystemUsersRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'users': ((json['users'] as Array<any>).map(BulkCreateSystemUserItemRequestFromJSON)),
        'subscriptionPlanId': json['subscriptionPlanId'],
        'countryState': json['countryState'],
    };
}

export function BulkCreateSystemUsersRequestToJSON(json: any): BulkCreateSystemUsersRequest {
    return BulkCreateSystemUsersRequestToJSONTyped(json, false);
}

export function BulkCreateSystemUsersRequestToJSONTyped(value?: BulkCreateSystemUsersRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'users': ((value['users'] as Array<any>).map(BulkCreateSystemUserItemRequestToJSON)),
        'subscriptionPlanId': value['subscriptionPlanId'],
        'countryState': value['countryState'],
    };
}

